'use client';

import { NodeResort } from '@/utils/drupal-api/__generated__/graphql';
import { ListingsFacets } from '@/utils/platform-api/__generated__/graphql';
import { ClientBrandConfig } from 'types/brand-config';

import { SearchBar } from '@/components/search/search-bar';

export type ListingQuickSearchProps = {
  brand: ClientBrandConfig;
  quickSearchTarget: string;
  resorts?: NodeResort[];
  style?: 'gray' | 'white';
  facets?: ListingsFacets;
  showFilters?: boolean;
  searchButtonText?: string;
  layout?: 'horizontal' | 'stacked';
};

const ListingQuickSearch: React.FC<ListingQuickSearchProps> = ({
  brand,
  quickSearchTarget,
  resorts,
  facets,
  showFilters,
  searchButtonText,
  layout,
}) => {
  return (
    <SearchBar
      brand={brand}
      quickSearchTarget={quickSearchTarget}
      resorts={resorts}
      facets={facets}
      showFilters={showFilters}
      searchButtonText={searchButtonText}
      shouldSubmit={false}
      layout={layout}
    />
  );
};

export default ListingQuickSearch;
